module.exports = require('./helpers/bundle-url').getBundleURL('kuLgW') + "subin.60d515bf.png";